import { COIN, CURRENCY_POSITION } from "constants";
/**
 * @param {number} value - The numeric value to format.
 * @returns {string} - The number formatted with two decimals and the currency symbol.
 * @throws {Error} - If the value is not a valid number.
 */
export function formatCurrency(value) {
  if (isNaN(value)) {
    throw new Error('El valor proporcionado no es un número válido.');
  }

  const formattedValue = Number(value).toFixed(2).replace('.', ',');
  return CURRENCY_POSITION === 'left'
    ? `${COIN} ${formattedValue}`
    : `${formattedValue} ${COIN}`;
}
